import { Card, Container, Row, Col, Table } from 'react-bootstrap';
import { useContext, useEffect, useState, useMemo } from 'react';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';
import Spinner from '../../components/Spinner';

import '../../styles/VCMAdminDashbord.css';

export default function VcmAdminDashboard() {
  const { userData } = useContext(AuthContext);
  const [statistics, setStatistics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCompanyStatistics();
  }, []);

  const fetchCompanyStatistics = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/admin/company-statistics`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setStatistics(response.data.statistics);
      } else {
        setError('Failed to fetch company statistics');
      }
    } catch (err) {
      console.error('Error fetching company statistics:', err);
      setError('Error loading company statistics');
    } finally {
      setLoading(false);
    }
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  const getUserName = () => {
    if (userData?.name) {
      return `${userData.name}`;
    }
    return "VCM Admin";
  };

  // Calculate statistics using useMemo to ensure they update when statistics change
  const totalCompanies = useMemo(() => {
    const count = statistics.length;
    return count;
  }, [statistics]);

  const totalAdmins = useMemo(() => {
    const count = statistics.reduce((sum, company) => {
      const adminCount = parseInt(company.admin_count) || 0;
      return sum + adminCount;
    }, 0);
    return count;
  }, [statistics]);
  
  return (
    <div className="vcm-admin-view-com-container mt-4">
      <div className="welcome-card">
        <div className="welcome-section">
          <h1 className="welcome-title">
            {getGreeting()}, {getUserName()}!
          </h1>
          <p className="welcome-subtitle">
            Manage and monitor all your companies from here
          </p>
        </div>

        {/* Statistics Cards */}
        <Row className="statistics-row">
          <Col md={6} className="mb-3 mb-md-0">
            <div className="stat-card">
              <div className="stat-icon success">
                <i className="bi bi-building"></i>
              </div>
              <div className="stat-value">{totalCompanies}</div>
              <div className="stat-label">Total Companies</div>
            </div>
          </Col>
          <Col md={6}>
            <div className="stat-card">
              <div className="stat-icon success">
                <i className="bi bi-people-fill"></i>
              </div>
              <div className="stat-value">{totalAdmins}</div>
              <div className="stat-label">Total Company Admins</div>
            </div>
          </Col>
        </Row>

        {/* Company Statistics Table */}
        <div className="table-card">
            <h2 className='stat-topic'>
              <i className="bi bi-bar-chart-fill me-2"></i>
              Company Statistics
            </h2>
          <div className="card-body">
            {loading ? (
              <div className="text-center py-5">
                <Spinner />
              </div>
            ) : error ? (
              <div className="alert alert-danger m-3">{error}</div>
            ) : statistics.length === 0 ? (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <i className="bi bi-inbox"></i>
                </div>
                <p>No companies found</p>
              </div>
            ) : (
              <div className="table-responsive">
                <Table className="company-table" hover>
                  <thead>
                    <tr>
                      <th>Company Name</th>
                      <th className="text-center">Company Admin Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {statistics.map((company) => (
                      <tr key={company.id}>
                        <td>
                          <strong>{company.company_name}</strong>
                        </td>
                        <td>
                          <strong> {company.admin_count || 0} </strong>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
